export const BLACK = '#000000';
export const BACKGROUND_0 = '#111216';
export const BACKGROUND_1 = '#20242b';
export const BACKGROUND_2 = '#21252c';
export const BACKGROUND_3 = '#39414d';
export const BACKGROUND_4 = '#556074';
export const TEXT = '#7f838b';
export const LINK_TEXT = '#bebdb2';
